import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "onduty-svg-recplay",
  "use": "onduty-svg-recplay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"onduty-svg-recplay\"><path fill=\"#d81e06\" d=\"M780.8 475.73l-494.935-307.2c-27.735-17.065-64 4.27-64 36.27v614.4c0 32 36.265 53.325 64 36.265l492.8-307.2c29.865-14.935 29.865-57.6 2.135-72.535z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol